import { CoreMenu } from "@core/types";
import { RoleNames } from "../constants/role-names";

//? DOC: http://localhost:7777/demo/vuexy-angular-admin-dashboard-template/documentation/guide/development/navigation-menus.html#interface

export const menu: CoreMenu[] = [
  // Dashboard
  {
    id: "analytics",
    title: "Analytics",
    translate: "MENU.DASHBOARD.ANALYTICS",
    type: "item",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-chart-simple",
    url: "dashboard/home",
  },
  {
    id: "country",
    title: "Country",
    icon: "fa-solid fa-globe",
    role: [RoleNames.Administrator], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/country",
  },
  {
    id: "regions",
    title: "Regions",
    role: [RoleNames.Administrator], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-map",
    type: "item",
    url: "dashboard/regions",
  },
  {
    id: "atm",
    title: "Atms",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-tablet",
    type: "item",
    url: "dashboard/atms",
  },
  {
    id: "staff",
    title: "Staff",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-user",
    type: "item",
    url: "dashboard/staffs",
  },
  {
    id: "transaction",
    title: "Transactions",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-dollar-sign",
    type: "item",
    url: "dashboard/transactions",
  },
  {
    id: "atm-logs",
    title: "Atm Logs",
    role: [RoleNames.Administrator], //? To set multiple role: ['Admin', 'Client']
    icon: "fa-solid fa-circle-exclamation",
    type: "item",
    url: "dashboard/atm-logs",
  },
  {
    id: "tickets",
    title: "Tickets",
    icon: "fas fa-ticket",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/tickets",
  },
  {
    id: "realtime",
    title: "Realtime",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    icon: "fas fa-clock",
    type: "item",
    url: "dashboard/realtime",
  },
  {
    id: "tracking",
    title: "Tracking",
    icon: "fas fa-compass",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/tracking",
  },
  {
    id: "networks",
    title: "Networks",
    icon: "fas fa-coins",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/networks",
  },
  {
    id: "tokens",
    title: "Tokens",
    icon: "fas fa-cube",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/tokens",
  },
  {
    id: "crypto-transaction",
    title: "Crypto Transaction",
    icon: "fas fa-wallet",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/crypto-transactions",
  },
  {
    id: "image",
    title: "Images",
    icon: "fas fa-image",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/images",
  },
  {
    id: "kyc",
    title: "KYC",
    icon: "fas fa-id-card",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor], //? To set multiple role: ['Admin', 'Client']
    type: "item",
    url: "dashboard/kycs",
  },
  {
    id: "partners",
    title: "Partners",
    icon: "fas fa-handshake",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/partners",
  },
  {
    id: "investors",
    title: "Investors",
    icon: "fas fa-briefcase",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/investors",
  },
  {
    id: "commission-config",
    title: "Commission Config",
    icon: "fas fa-sliders-h",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/commission-config",
  },
  {
    id: "withdrawal-requests",
    title: "Withdrawal Requests",
    icon: "fas fa-money-bill-wave",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/withdrawal-requests",
  },
  {
    id: "commission-transactions",
    title: "Commission Transactions",
    icon: "fas fa-percent",
    role: [RoleNames.Administrator, RoleNames.Manager, RoleNames.Supervisor],
    type: "item",
    url: "dashboard/commission-transactions",
  },
  {
    id: "partner-staffs",
    title: "Partner Staff",
    icon: "fas fa-users",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/partner-staffs",
  },
  {
    id: "ghana-banks",
    title: "Ghana Banks",
    icon: "fas fa-building-columns",
    role: [RoleNames.Administrator],
    type: "item",
    url: "dashboard/banks",
  },
  // Investor menu
  {
    id: "investor-analytics",
    title: "Analytics",
    icon: "fa-solid fa-chart-simple",
    role: [RoleNames.Investor],
    type: "item",
    url: "dashboard/investor/home",
  },
  {
    id: "investor-transactions",
    title: "Transactions",
    icon: "fa-solid fa-dollar-sign",
    role: [RoleNames.Investor],
    type: "item",
    url: "dashboard/investor/transactions",
  },
  {
    id: "investor-withdrawals",
    title: "Withdrawals",
    icon: "fas fa-money-bill-wave",
    role: [RoleNames.Investor],
    type: "item",
    url: "dashboard/investor/withdrawals",
  },
  // Partner menu
  {
    id: "partner-analytics",
    title: "Analytics",
    icon: "fa-solid fa-chart-simple",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/home",
  },
  {
    id: "partner-transactions",
    title: "Transactions",
    icon: "fa-solid fa-dollar-sign",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/transactions",
  },
  {
    id: "partner-withdrawals",
    title: "Withdrawals",
    icon: "fas fa-money-bill-wave",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/withdrawals",
  },
  {
    id: "partner-atms",
    title: "ATMs",
    icon: "fa-solid fa-tablet",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/atms",
  },
  {
    id: "partner-staff",
    title: "Staff",
    icon: "fa-solid fa-user",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/staff",
  },
  {
    id: "partner-kycs",
    title: "KYCs",
    icon: "fas fa-id-card",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/kycs",
  },
  {
    id: "partner-atm-logs",
    title: "ATM Logs",
    icon: "fa-solid fa-circle-exclamation",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/atm-logs",
  },
  {
    id: "partner-tickets",
    title: "Tickets",
    icon: "fas fa-ticket",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/partner/tickets",
  },
  {
    id: "partner-ghana-banks",
    title: "Ghana Banks",
    icon: "fas fa-building-columns",
    role: [RoleNames.Partner],
    type: "item",
    url: "dashboard/banks",
  },
];
